import { useEffect } from "react";

import { IntlProvider } from "react-intl-next";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";

import { useLocale } from "@/libraries/web-framework";
import { experiments, useExperiment } from "@/utils/experiment";

import { ANALYTICS_PREFIX } from "../../../../onboarding-wizard/common/constants";
import { LeftHandSidePageInvite } from "../../../../onboarding-wizard/wizard/variant/jfind-1663-page-invite/left-hand-side/left-hand-side";
import { StepContext, StepProps } from "../../../types";

export const Invite = <T extends StepContext>({
    context,
    nextStep
}: StepProps<T>) => {
    const { teamType, template } = context;
    const locale = useLocale();
    const { createAnalyticsEvent } = useAnalyticsEvents();

    const experiment = useExperiment(
        experiments.jfindOnboardingWizardInviteStep
    );

    const isEnrolledInInviteTreatment =
        experiment.type === "enrolled" && experiment.value === true;

    useEffect(() => {
        if (isEnrolledInInviteTreatment) {
            createAnalyticsEvent({
                action: "viewed",
                eventType: "screen",
                name: `${ANALYTICS_PREFIX}InviteStep`,
                attributes: {
                    teamType,
                    template
                }
            }).fire();
        }
    }, [createAnalyticsEvent, teamType, template]);

    useEffect(() => {
        if (!isEnrolledInInviteTreatment) {
            nextStep();
        }
    }, [isEnrolledInInviteTreatment, nextStep]);

    return (
        <IntlProvider locale={locale}>
            <LeftHandSidePageInvite onClickNext={nextStep} />
        </IntlProvider>
    );
};
